import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { NotificationOptions } from '../types/notification-options';

/**
 * Update notifications preferences DTO
 */
export class UpdateNotificationPreferencesDto {
	@TransformInt()
	id!: number;
	color?: string;
	@TransformInt()
	userId?: number;
	browser?: NotificationOptions;
	email?: NotificationOptions;
	inbox?: NotificationOptions;
	push?: NotificationOptions;
	sms?: NotificationOptions;
	webhook?: NotificationOptions;
}
